import { IRootState } from "~/types/store/root";

const state: () => IRootState = () => ({
    region: null,
    flash: null,
    showMenu: false,
    showLoginForm: false,
    loginFormParams: null,
    user: null,
    favoriteCount: 0,
    orderCount: 0,
    siteBroken: false,
    pageNotFound: false,
    history: [],
    recentSearch: [],
    token: null,
    shouldCleanBreadcrumbs: false,
    shouldKeepScroll: false,
    breadcrumbs: [],
    imageFormat: 'jpeg',
});

export default state;
